import React from 'react';
import styled, { keyframes } from 'styled-components';

const gradientAnimation = keyframes`
  to {
    background-position-x: -20%;
  }
`;

const Element = styled.div`
  border-radius: 8px;
  min-height: ${(props) => props.height || '100px'};
  background: #f9fafb;
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  background: linear-gradient(
      100deg,
      rgba(255, 255, 255, 0) 40%,
      rgba(26, 26, 46, 0.1) 50%,
      rgba(255, 255, 255, 0) 60%
    )
    #f9fafb;

  background-size: 200% 100%;
  background-position-x: 180%;
  animation: 1s ${gradientAnimation} ease-in-out infinite;
`;

const SkeletonLoading = ({ width, height }) => (
  <Element width={width} height={height} />
);

export default SkeletonLoading;
